<template>
  <div class="md-layout" style="background-color: #f2f2f2">
      <div class="md-layout-item md-size-55 md-small-size-100">
            <div class="item-cert-carboon" style="position: relative;">
              <img alt="Cuadro de detalles" src="@/assets/CUADRO-M-UP.png"  srcset="" class="cuadro-detalles">
              <img alt="Productos con huella de carbon neutral" src="@/assets/CARBON-NEUTRAL-PRODUCT.png" style="width: 30%; position: absolute; bottom: -5%; left:50%;" />
            </div>
      </div>
      <div class="md-layout-item huella-text md-small-size-100 mt-4">
        <h1 class="gestion-huella" style="font-size: 4vw; text-align: justify;">CARBONO NEUTRAL</h1>
        <p style="font-weight: bold;">Certificación de Neutralización de Huella de Carbono.</p>
        <p>Esta certificación garantiza que se han contabilizado y neutralizado las emisiones de gases de efecto invernadero asociadas  a una empresa, producto o servicio.</p>
        <div style="text-align: left;">
            <md-button class="md-raised md-cert md-elevation-4" style="background-color: #00d371 !important; color: #e5e5e5 !important" @click="handleClick">
               <img alt="Calendario" src="@/assets/date.svg"  srcset="" width='20px' style="margin-right: 10px; margin-top: -5px" />
               <span>AGENDA UNA REUNIÓN</span> 
              <md-tooltip md-direction="bottom">Agenda una reunión con un ejecutivo</md-tooltip>      
            </md-button>
        </div>
      </div>
      <div style="width: 100%">
          <div class="brouche-carbon md-elevation-20" STYLE="background-color: #00d371;">
            <a href="/descargar/Brochure-hdc.pdf" download="reporte" style="color: #ffff">
              <img alt="Huella de carbono brouche" src="@/assets/huella-carbono-brouche.png"   srcset="" style=" font-weight: bold !important; position: absolute; left: -15%;top: -60%; width: 15rem;" >
              <h2>HUELLA DE CARBONO</h2>
              <h2>DESCARGA NUESTRO BROCHURE</h2>
            </a>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'cuadro-neutral',
    methods: {
      handleClick() {
      gtag( 'event', 'Click',{
          event_category: 'Agendar',
          event_label: 'calendly',
          value: 0
      })
      this.$store.state.showDialog = true
    }
    }

}
</script>

<style>

</style>